@if(present()) {
  <div class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
    <ng-content select="[body]"></ng-content>
  </div>
}



